import { render, staticRenderFns } from "./CommonPageContainer.vue?vue&type=template&id=262c2be7&scoped=true"
import script from "./CommonPageContainer.vue?vue&type=script&lang=js"
export * from "./CommonPageContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonPageContainer.vue?vue&type=style&index=0&id=262c2be7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262c2be7",
  null
  
)

export default component.exports